// extracted by mini-css-extract-plugin
export default {"container":"shell__container--MVoVF","main-content":"shell__main-content--HleNf","footer":"shell__footer--fHfZK"};